module.exports = __webpack_public_path__ + "static/media/Event7.8ca76c76.jpg";